<script>
  import { onMount } from 'svelte'
  import TextField from 'smelte/src/components/TextField/TextField.svelte'

  export let items = []
  export let valueProp = null
  export let label = ''
  export let top = null

  $: _top = top ? 'top:' + top : 'top: 2.3em;'

  let items1 = []

  onMount(() => {
    // console.log('[DEBUG] ' + label, items)
  })

  function keyupHandler (event) {
    if (event.target.value === '' && items1 != null) {
      items1 = []
      return
    }
    const key = event.target.value.toLowerCase()
    items1 = items.filter(p => p.toLowerCase().startsWith(key)).slice(0, 30)
      .sort((a, b) => {
        return a < b ? -1 : 1
      })
  }

  function itemSelectHandler (item) {
    valueProp = item
    items1 = []
  }

  function outHandler (event) {
    setTimeout(() => {
      items1 = []
    }, 300)
  }
</script>

<div class="relative input-text bg-gray-200">
  <TextField noUnderline
         bind:value={valueProp}
         label={label}
         append="clear"
         iconClass="text-gray-400 cursor-pointer"
         on:click-append={() => valueProp = null}
         on:keyup={keyupHandler}
         on:blur={outHandler}
  />


  <div class="absolute bg-white shadow w-full text-base overflow-y-auto text-gray-700"
       style={'max-height: 9em; z-index:auto; z-index: 1000;' + _top}>
    {#each items1 as country}
      <div class="py-1 px-3 hover:bg-gray-300"
           on:click={() => {itemSelectHandler(country)}}
      >
        {country}
      </div>
    {/each}
  </div>
</div>